import {getCenterId,} from "@/api/general";
import BigFotoBack from "@/components/bigFotoBack/BigFotoBack";
import CustomTitle from "@/components/custom_title";
import RektorCard from "@/components/tuzilma/RektorCard";
import Layout from "@/locales/en/layout/Layout";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useQuery} from "react-query";
import bg from "../../../assets/markazlar/ATM.jpg"
import {HodimlarWrapper} from "@/components/tuzilma/TuzilmaWrapper";
import ImageGallery from "react-image-gallery";

import img1 from "../../../assets/bolimlar/aliyev.jpg"
import img2 from "../../../assets/bolimlar/Abbos.jpg"
import img3 from "../../../assets/bolimlar/Erkinov D.jpg"
import img4 from "../../../assets/bolimlar/Dustali.jpg"


const M2 = () => {
    const {data} = useQuery({
        queryKey: ["centerid", 2],
        queryFn: () => getCenterId(2),
    });
    let datas = data?.data?.data[0];
    const {t} = useTranslation();

    const [data1, setData1] = useState([]);
    const [dataUZ] = useState([
        {
            id: '1',
            img: img1,
            name: "Aliyev Davron Tursunmuhammad o'g'li",
            position: "Texnik qo‘llab-quvvatlash bo‘limi boshlig'i",
            phone: '+99871 207 44 45',
            email: 'rttm@tdtu.uz',
        },
        {
            id: '2',
            img: img2,
            name: "Miryoqubov Mirabbos Xusanovich",
            position: "Axborot xavfsizligini ta'minlash bo'limi boshlig'i",
            phone: '+99871 207 44 45',
            email: 'm.miryoqubov@tdtu.uz',
        },
        {
            id: '3',
            img: img3,
            name: "Erkinov Dilmurod Doniyor o'g'li",
            position: "Tarmoqlarni boshqarish bo'limi boshlig'i",
            phone: "+99871 207 44 45",
            email: 'rttm@tdtu.uz',
        },
        {
            id: '4',
            img: img4,
            name: 'Avlayev Dusali Yusupovich',
            position: "Raqamli ta’lim texnologiyalarini joriy etish bo‘limi boshlig‘i",
            phone: "+99871 207 44 45",
            email: "dust-ali@rambler.ru",
        },
    ]);

    const [dataEN] = useState([
        {
            id: '1',
            img: img1,
            name: "Aliyev Davron Tursunmuhammad ogli",
            position: "Head of technical support department",
            phone: '+99871 207 44 45',
            email: 'rttm@tdtu.uz',
        },
        {
            id: '2',
            img: img2,
            name: "Miryoqubov Mirabbos Xusanovich",
            position: "Head of the Information Security Department",
            phone: '+99871 207 44 45',
            email: 'rttm@tdtu.uz',
        },
        {
            id: '3',
            img: img3,
            name: "Erkinov Dilmurod Doniyor ogli",
            position: "Head of Network Management Department",
            phone: "+99871 207 44 45",
            email: 'rttm@tdtu.uz',
        },
        {
            id: '4',
            img: img4,
            name: 'Avlayev Dusali Yusupovich',
            position: "Head of the department of introduction of digital educational technologies",
            phone: "+99871 207 44 45",
            email: "dust-ali@rambler.ru",
        },
    ]);
    const [dataRU] = useState([
        {
            id: '1',
            img: img1,
            name: "Алиев Даврон Турсунмухаммед угли",
            position: "Начальник отдела технической поддержки",
            phone: '+99871 207 44 45',
            email: 'rttm@tdtu.uz',
        },
        {
            id: '2',
            img: img2,
            name: "Мирёкубов Мираббос Хусанович",
            position: "Начальник отдела информационной безопасности",
            phone: '+99871 207 44 45',
            email: 'rttm@tdtu.uz',
        },
        {
            id: '3',
            img: img3,
            name: "Эркинов Дилмурод Дoниёр угли",
            position: "Начальник отдела управления сетью",
            phone: "+99871 207 44 45",
            email: 'rttm@tdtu.uz',
        },
        {
            id: '4',
            img: img4,
            name: 'Авлаев Дусали Юсупович',
            position: "Начальник отдела внедрения цифровых образовательных технологий",
            phone: "+99871 207 44 45",
            email: "dust-ali@rambler.ru",
        },
    ]);

    useEffect(() => {
        if (localStorage.getItem("i18nextLng") === "ru") {
            setData1(dataRU)
        } else if (localStorage.getItem("i18nextLng") === "uz") {
            setData1(dataUZ)
        } else {
            setData1(dataEN)
        }
    }, [dataRU, dataUZ, dataEN]);

    document.title = t("header.header__sub__menu.menu-1.item-2")
    // const [gallery] = useState([
    //     {
    //         original: img1,
    //         thumbnail: img1,
    //     },
    //     {
    //         original: img2,
    //         thumbnail: img2,
    //     },
    //     {
    //         original: img3,
    //         thumbnail: img3,
    //     },
    // ]);

    return (
        <>
            <Layout>
                <BigFotoBack
                    img={bg}
                    text={t("header.header__sub__menu.menu-1.item-2")}
                />
                <CustomTitle name={t("header.header__sub__menu.menu-1.item-2")}/>
                <div className="container">
                    <RektorCard
                        key={datas?.id}
                        time={datas?.acceptance}
                        degree={datas?.degree}
                        position={datas?.position}
                        name={datas?.directorname}
                        img={datas?.director_img}
                        address={datas?.email}
                        phone={datas?.phone}
                    />

                </div>
                <HodimlarWrapper>
                    <div className="news-head">
                        <div className="container">
                            <p>{t("Hodimlar")}</p>
                        </div>
                    </div>
                    <div className="container">
                        <div className="card-news">
                            {data1.map((v, i) => (
                                <div key={v.id} className="box-hodimlar">
                                    <img
                                        src={(v.img)}
                                        alt=""
                                    />
                                    <div className="text-box">
                                        <p className="bold">
                                            {v.name}
                                        </p>
                                        <p>
                                            <span className="bold">{t("person.Lavozimi")}</span> {v.position}
                                        </p>
                                        <p>
                                            <span className="bold">{t("person.Telefon")}</span> {v.phone}
                                        </p>
                                        <p>
                                            <span className="bold">{t("person.mail")} </span> {v.email}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </HodimlarWrapper>
                <CustomTitle name={""}/>
                <div className="container">
                    <div dangerouslySetInnerHTML={{__html: datas?.text}}/>
                    Universitetning raqamli infratuzilmasini rivojlantirish – universitetning barcha bo‘limlari uchun zamonaviy axborot tizimlarini ishlab chiqish va joriy etish;
                    Axborot xavfsizligini ta’minlash – universitetning raqamli ma’lumotlarini himoya qilish, kiberxavfsizlik choralarini ko‘rish;
                    Elektron ta’lim tizimlarini rivojlantirish – masofaviy ta’lim platformalarini ishlab chiqish va ularni talabalar hamda professor-o‘qituvchilar uchun qulay qilish;
                    Universitet veb-saytlari va axborot tizimlarini boshqarish – rasmiy veb-saytlarni yaratish, ularning uzluksiz ishlashini ta’minlash va foydalanuvchilar uchun qulay interfeyslarni ishlab chiqish;
                    Dasturiy ta’minot va texnik qo‘llab-quvvatlash xizmatlarini ko‘rsatish – universitetdagi axborot texnologiyalari bilan bog‘liq muammolarni hal qilish va dasturiy vositalarni yangilab borish;
                    Ilmiy va innovatsion loyihalarni qo‘llab-quvvatlash – universitet professor-o‘qituvchilari va talabalari uchun innovatsion IT-loyihalarini yaratishda ko‘mak berish;
                    {/*<ImageGallery items={gallery}/>*/}

                </div>
            </Layout>
        </>
    );
};

export default M2;
